<template>
  <div class="alipaySendPage">
    <XR-head titleText="支付宝支付" :rightShow="false"></XR-head>    
    
    <span v-html="html"></span>

    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data(){
    return {   
      html:''
    }
  },
  mounted(){
    this.getAlipayHtml()
  },
  methods:{
    getAlipayHtml(){
      this.orderNo = window.localStorage.OrderPayNo
      if(!this.orderNo){
        ths.$refs.XRtoast.failed('请重新下单', true)
        return
      }
      
      var ths = this;   
      ths.$post(
        "/Shop/AlipayServer/GetAlipayHtml",
        {orderNo:this.orderNo}
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.loaded=false             
          ths.$refs.XRtoast.hide()
          ths.html = res.Data
        }
      });
    }
  }
}
</script>

<style>
.alipaySendPage input{
  width:90%;
  height: 50px;
  margin: 20px 5%;
}
</style>



// WEBPACK FOOTER //
// src/pages/retail/pay/alipaySend.vue